import { gsap } from "gsap";

function animateOnVisible(element, animationFunction, once = true) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animationFunction();
          if (once) observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  observer.observe(element);
}

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".howwework");
  if (!container) return;

  const steps = gsap.utils.toArray(".howwework__wrapper__item");
  if (!steps.length) return;

  animateOnVisible(container, () => {
    gsap.fromTo(
      steps,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power1.out",
      }
    );
  });
});
